const strings: [string, string][] = [
  ['stencilset-displayname', 'Flowchart'],

  ['ProcessStencil-displayname', 'Process'],
  ['DecisionStencil-displayname', 'Decision'],
  ['IOStencil-displayname', 'Input/Output'],
  ['TerminalStencil-displayname', 'Terminal'],

  ['LabelStencil-displayname', 'Label'],
  ['BitmapImageStencil-displayname', 'Image'],

  ['ArrowConnector-displayname', 'Flowline'],
  ['CurvedArrowConnector-displayname', 'Flow curve'],
];

export default strings;
